export class DeskTranslation {
    public id: number;
    public deskId: number;
    public name: string;
    public deskFullNamePronunciation: string;
    public roomNumberPronunciation: string;
    public translationId: number;
    public locationId: number;
}